<template>
  <main>
    <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
    <b-container id="scrollToOnLoad">
      <section class="section--saved_selection" id="scrollToOnLoad">
        <h2 class="text-center">
          {{ $t("reportResults.title") }}
          <span
            class="text--shadow-center"
          >{{ $t("reportResults.title") }}</span>
        </h2>
        <p class="text-center">{{ $t("reportResults.header") }}</p>
      </section>
      <section class="experiments">
        <div v-for="(experiment, i) in experimentsList" :key="i">
          <list-of-experiments :experiment="experiment"></list-of-experiments>
        </div>
        <h3 v-if="!experimentsList.length">{{ $t("reportResults.alert") }}</h3>
        <a
          v-else
          :href="`/static/assets/Make_a_Molecule_Workshop_Conclusion_form_${locale}.pdf`"
          download
          class="btn btn-primary report"
        >{{ $t("reportResults.download") }}</a>
      </section>
    </b-container>
    <section-support></section-support>
  </main>
</template>

<script>
import game from '@/api/v1/game';
import Hero from '@/components/Hero';
import Support from '@/components/Support/Index';
import ListOfExperiments from '@/components/ListOfExperiments';

export default {
  components: {
    'section-hero': Hero,
    'section-support': Support,
    ListOfExperiments,
  },
  data() {
    return {
      bgImg: 'Banner2-Experiment-',
      subtitle: this.$t('nav.experiment'),
      experimentsList: [],
      locale: localStorage.getItem('lang'),
    };
  },
  methods: {
    getExperimentsList() {
      const succ = (response) => {
        this.experimentsList = response.data.experiments.filter(
          experiment => !experiment.has_results,
        );
      };
      game.getExperimentsList(succ);
    },
  },
  created() {
    this.getExperimentsList();
  },
};
</script>

<style lang="scss" scoped>
@import "./src/styles/helpers/_variables.scss";
@import "./src/styles/helpers/_include-media.scss";
.section {
  &--saved_selection {
    padding: 130px 0 100px;
  }
}
.experiments {
  padding: 0 0 100px;
}
.report {
  display: block;
  width: 40%;
  margin: 0 auto;
  border-radius: 23.5px;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/Game/ReportMyResults.vue